import "./base";


//
// Modul pro recaptchu od Google

//
window.Modules.GoogleRecaptcha = {

	//
	// Nahrání externích skriptů
	//
	// params.callbackName ... jméno callback funkce, která se zavolá po inicializaci
	//
	load: function(params) {
		var language = document.documentElement.getAttribute("lang");
		language = language ? ("&hl=" + language) : "";

		window.Modules.loadScript("https://www.google.com/recaptcha/api.js?render=explicit&onload=" + params.callbackName + language);
	},


};
